import React from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardHeader, CardMedia } from '@mui/material';

import { MultiButton, ImageAvatar, Text, useSettings, Utils } from 'app/main/components';
import { type ItemLayoutProps } from 'app/main/components/GridList';
import buttons from './CompaniesButtons';

export default function CompaniesGridItem({ model, buttonProps }: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const avatarPath = `${import.meta.env.VITE_ENDPOINT}/resources/companies/${model.comp_uid}/${
		model.comp_business_card_front
	}`;

	return (
		<Card variant="outlined">
			<CardMedia className="h-320" component="img" height="320" image={avatarPath} alt="business-card-front" />
			<CardHeader
				avatar={
					<ImageAvatar
						dimensions={44}
						module="companies"
						uid={model.comp_uid}
						avatar={model.comp_avatar}
						initials={model.comp_title_initials}
					/>
				}
				action={
					<MultiButton
						buttonProps={{ ...buttonProps, dispatch, t }}
						items={buttons.view?.itemButtons || []}
					/>
				}
				title={
					<Text
						className="font-600"
						variant="subtitle2"
						color="text.primary"
						to={{ module: 'companies', uid: model.comp_uid }}
					>
						{model.comp_title}
					</Text>
				}
				subheader={
					<>
						<Text variant="subtitle2" color="text.secondary">
							{model.comp_address || ''}
						</Text>
						<Text variant="subtitle2" color="text.secondary">
							{Utils.formatAddress2({
								t,
								address: {
									zip: model.comp_zip,
									city: model.comp_city,
									district: model.dist_iso,
									country: model.ctry_title
								}
							})}
						</Text>
					</>
				}
			/>
		</Card>
	);
}
